import React from "react";
import { Link } from "react-router-dom";
import coins from "./../../assets/icons/coin.svg";
import Rating from "./Rating";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "../../store/reducers/cart-slice-reducer";
import { toast } from "react-toastify";
import { setIsLoginModalOpen } from "../../store/reducers/global-reducer";
import WishlistHeart from "./WishlistHeart";
import "../../assets/css/product-card.css";

function getStockQty(quantity) {
  if (quantity == null) return 0;
  if (typeof quantity === "number") return quantity;
  if (typeof quantity === "object") return quantity.stock_qty ?? 0;
  return 0;
}

const ProductCard = ({ data }) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const stockQty = getStockQty(data.quantity);
  const inStock = stockQty > 0;
  const isLowStock = inStock && stockQty <= 3;

  const openmodalHandler = () => {
    toast.error("Buyer login failed....");
    setTimeout(() => {
      dispatch(setIsLoginModalOpen({ isLoginModalOpen: true }));
      document.body.style.overflow = "hidden";
    }, 2000);
  };

  const handleAddToCart = (goToCart = false) => {
    dispatch(
      addToCart({
        id: data.id,
        name: data.name,
        image: data.image,
        price: data.price,
        quantity: goToCart ? undefined : 1,
        coins: data.super_rewards === true ? 2 : 0,
        color: data.color_size?.[0]?.color ?? '',
        size: data.color_size?.[0]?.size ?? '',
        stock: stockQty,
      })
    );
  };

  const detailPath =
    data.isService === false
      ? `/product-detail/${data.id}`
      : `/service-detail/${data.id}`;

  return (
    <div className="prod_card">
      {data.super_rewards === true ? (
        <img
          src={coins}
          alt="coin-icon"
          loading="lazy"
          decoding="async"
          width={45}
          height={45}
        />
      ) : (
        ""
      )}
      <div className="img_wrapper">
        {data.isService === true ? (
          <div className="ep_tag shadow">
            <span>EP: {data.videoCount}</span>
          </div>
        ) : (
          ""
        )}

        <div className="btns_wrapper">
          <div className="share_option shadow">
            <WishlistHeart productId={data.id} />
          </div>
        </div>
        <Link to={detailPath}>
          <img
            src={data.image}
            loading="lazy"
            decoding="async"
            className="img-fluid"
            alt={data.name || "Product"}
          />
        </Link>
      </div>
      <div className="text_wrapper">
        <div className="prod_info_head">
          <div className="prod_info">
            <Rating avgRating={data.avgRating} />
            <p className="product_name">
              <Link to={detailPath}>{data.name}</Link>
            </p>
          </div>
        </div>

        <div className="prod_foot">
          {inStock ? (
            <div className="prod_foot__actions d-flex justify-content-between">
              {isLoggedIn ? (
                <>
                  <Link
                    className="btn custom_btn btn_yellow_bordered"
                    to="/my-cart"
                    onClick={() => handleAddToCart(true)}
                  >
                    Buy Now
                  </Link>
                  <Link
                    className="btn custom_btn btn_yellow_bordered"
                    to="#"
                    onClick={() => handleAddToCart(false)}
                  >
                    Add to cart
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    className="btn custom_btn btn_yellow_bordered"
                    to="#"
                    onClick={openmodalHandler}
                  >
                    Buy Now
                  </Link>
                  <Link
                    className="btn custom_btn btn_yellow_bordered"
                    to="#"
                    onClick={() => handleAddToCart(false)}
                  >
                    Add to cart
                  </Link>
                </>
              )}
            </div>
          ) : (
            <div className="prod_foot__actions prod_foot__actions--placeholder" aria-hidden="true" />
          )}

          <p
            className={`prod-card-stock-status${
              !inStock
                ? " prod-card-stock-status--out"
                : isLowStock
                  ? " prod-card-stock-status--low"
                  : " prod-card-stock-status--empty"
            }`}
          >
            {!inStock
              ? "Out of stock"
              : isLowStock
                ? `Only ${stockQty} stock left`
                : "\u00a0"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
